module.exports = __webpack_public_path__ + "static/media/Siren.4a254554.mp3";